import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 168px;
  min-height: 100vh;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
`;

export const Main = styled.main`
  padding: 24px;
  flex: 1;
`;
